import React, { useState } from 'react'
import styled from 'styled-components'
import { GrEdit, GrClose } from 'react-icons/gr'
import colors from 'utils/colors'
import mixins from 'utils/mixins'

const Edit = styled.button`
  display: none;
  position: absolute;
  top: -24px;
  right: -24px;
  border-radius: 50px;
  background-color: rgba(0,0,0,.14);
  &:hover {
    background-color: ${colors.blue};
  }
`

const FieldSet = styled.fieldset`
  ${mixins.card}
  border-top: 2px solid ${props => props.borderColor};
  position: relative;
  &:hover ${Edit} {
    display: block;
  }
`

const Header = styled.div`
  cursor: pointer;
`

const Controls = styled.div`
  border-top: .5px solid ${colors.grey};
  padding: 30px 0;
  margin-top: 30px;
`

export default ({ header, children, icon, sectionId}) => {
  const [open, setOpen] = useState(false)

  let borderColor
  if (sectionId === 'Income') {
    borderColor = colors.green
  } else if (sectionId === 'Liabilities') {
    borderColor = colors.red
  } else {
    borderColor = colors.blue
  }

  return (
    <FieldSet borderColor={borderColor}>
      <Edit onClick={() => setOpen(!open)} type="button"> 
        {open 
          ? <GrClose />
          : icon ? icon : <GrEdit />}
      </Edit>

      <Header onClick={() => setOpen(!open)}>
        { header }
      </Header>

      { open && (
        <Controls>
          { children }
        </Controls>
      )}
    </FieldSet>
  )
}